import React from 'react';
import PropTypes from 'prop-types';

const LinkButton = ({ className, children, ...buttonAttributes }) =>
  <button className={`link-button ${className || ''}`}
          {...buttonAttributes}>
    {children}
  </button>;

LinkButton.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default LinkButton;
